jQuery(document).ready(function($) {

    if ($('video').length < 1) {
        return;
    }

    $('video').attr('playsinline', true);

});